import CsatByAnswerToOtherQuestionBarChart from './CsatByAnswerToOtherQuestionBarChart';
export default CsatByAnswerToOtherQuestionBarChart;



// WEBPACK FOOTER //
// ./src/components/CsatByAnswerToOtherQuestionBarChart/index.js